const EyeIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
      fill="#F4EFED"
    />
    <path
      d="M40 10.667C58.7698 10.667 74.6565 23.0038 79.998 40.0107C74.6567 57.0182 58.7701 69.3555 40 69.3555C21.2298 69.3554 5.34214 57.0183 0.000976562 40.0107C5.34243 23.0036 21.2302 10.6671 40 10.667Z"
      fill="white"
    />
    <ellipse cx="40" cy="40.001" rx="14" ry="14" fill="#0A0777" />
  </svg>
);

export default EyeIcon;
